import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flag", "hiddenModalTrigger", "checkbox"]

  dynamicDownload() {
    const checkboxes = document.querySelectorAll('[data-site-checkbox-button-target="checkbox"]')
    const anyCheckboxChecked = Array.from(checkboxes).some(c => c.checked)
    if (anyCheckboxChecked) {
      this.partialDownload()
    } else {
      this.totalDownload()
    }
  }

  totalDownload() {
    document.dispatchEvent(
      new CustomEvent("select-all:enabled")
    )

    this.hiddenModalTriggerTarget.click()

    const formFlag = document.querySelector('#selection_form input[name="select_all"]')
    if (formFlag) {
      formFlag.value = "true"
    }
  }

  partialDownload() {
    document.dispatchEvent(
      new CustomEvent("select-all:disabled")
    )

    this.hiddenModalTriggerTarget.click()

    const formFlag = document.querySelector('#selection_form input[name="select_all"]')
    if (formFlag) {
      formFlag.value = "false"
    }
  }
}
